import React from 'react';
import { injectIntl } from 'react-intl';
import { useTheme } from 'ThemeContext';
import { Breakpoints } from 'assets/Variables.style';
import { Wrapper, Image, Link, Mourning, Source } from './Logo.style';

import MOURNING_ICON from 'assets/Images/mourning.png';

function Logo({ intl, name = undefined, logo = undefined, mourning = false }) {
  const theme = useTheme();

  const regExp = new RegExp('(.*)(.jpg|.jpeg|.png)$');
  let currentLogoMatch;
  let currentLogo = logo;
  let currentLogoTablet;
  let currentLogoMobile;

  //Serwer nie obsługuje dla logo.
  if (false && logo) {
    currentLogoMatch = currentLogo.match(regExp);
    if (currentLogoMatch && currentLogoMatch[1] && currentLogoMatch[2]) {
      currentLogo = `${currentLogoMatch[1]}_${theme.header.logo.image.width}x${
        theme.header.logo.image.height
      }${theme.header.logo.image.crop === 0 ? '_0' : '_1'}${
        currentLogoMatch[2]
      }`;
      currentLogoTablet = `${currentLogoMatch[1]}_${
        theme.header.logo.image.widthTablet
      }x${theme.header.logo.image.heightTablet}${
        theme.header.logo.image.crop === 0 ? '_0' : '_1'
      }${currentLogoMatch[2]}`;
      currentLogoMobile = `${currentLogoMatch[1]}_${
        theme.header.logo.image.widthMobile
      }x${theme.header.logo.image.heightMobile}${
        theme.header.logo.image.crop === 0 ? '_0' : '_1'
      }${currentLogoMatch[2]}`;
    }
  }

  return (
    <Wrapper theme={theme.logo && theme.logo.wrapper}>
      <Link to='/' title={intl.formatMessage({ id: 'LOGO.GO_TO_HOMEPAGE' })}>
        {currentLogoTablet && (
          <Source
            media={`(max-width: ${Breakpoints.md}px)`}
            srcSet={currentLogoTablet}
          />
        )}
        {currentLogoMobile && (
          <Source
            media={`(max-width: ${Breakpoints.sm}px)`}
            srcSet={currentLogoMobile}
          />
        )}
        <Image src={currentLogo} loading='lazy' alt={name} theme={theme.logo} />
        {mourning ? <Mourning src={MOURNING_ICON} loading='lazy' alt='' /> : ''}
      </Link>
    </Wrapper>
  );
}

export default injectIntl(Logo);
